import { Argocomponent, componentName, componentStatus } from "./component";

// export interface videoParams {
//     width: number;
//     height: number;
//     frameRate:number;
//     facingMode:string;
// }

export class VideoComponent extends Argocomponent {
    private _videoSettings: any = null;
    //private _stream:MediaStream = null
    private _videoCanvas: HTMLCanvasElement;
    private _videoElement: HTMLVideoElement;
    //private _trackConstraints:any;
    private _mediaConstraints: MediaStreamConstraints = {};
    private frameRate = 0;

    private context2d: CanvasRenderingContext2D = null;
    //private isIOS:boolean
    private mp4VideoPath = "";
    private imageDataSync: any;
    private videoMaxSize = 640;
    private stream: MediaStream;

    //private debug_iterator:number=0

    constructor(container: HTMLElement, options: any = {}) {
        super();
        if (options == undefined) {
            options = {};
        }
        if (options.trackConstraints == undefined) {
            options.trackConstraints = {
                facingMode: {
                    ideal: "environment"
                },
                width: {
                    min: 480,
                    ideal: 640,
                    max: 1000
                },
                height: {
                    min: 480,
                    ideal: 480,
                    max: 1000
                },
                frameRate: {
                    min: 30,
                    ideal: 60
                }
            };
        }
        const videoId = options.videoId || "webcam";
        this.name = componentName.VIDEO;
        //this.isIOS=_webArgo.profile.isIOS
        //console.log("isIOS="+this.isIOS)
        //this._trackConstraints=options.trackConstraints;
        if (options.mp4VideoPath != undefined) {
            this.mp4VideoPath = options.mp4VideoPath;
        }

        this._mediaConstraints.audio = false;
        this._mediaConstraints.video = options.trackConstraints as MediaTrackConstraints;

        this._videoElement = document.getElementById(videoId) as HTMLVideoElement;
        if (this._videoElement == undefined) {
            this._videoElement = document.createElement("video");
        }
        this._videoElement.id = videoId;

        //this._videoElement.autoplay = options.autoStart;
        this._videoElement.setAttribute("playsinline", "true");

        this._videoCanvas = document.createElement("canvas") as HTMLCanvasElement;
        this._videoCanvas.id = "videoCanvas";

        this.context2d = this._videoCanvas.getContext("2d");
        /*
        if(this.webArgo.profile.isIOS){
            this.webArgo.argoDiv.appendChild(this._videoElement);
        }
        */
        container.appendChild(this._videoElement);
        this.newStatus(componentStatus.LOADING);

        this._videoElement.addEventListener("playing", () => {
            this._videoSettings = { width: 0, height: 0, aspectRatio: 0 };
            this._videoSettings.width = this._videoElement.videoWidth;
            this._videoSettings.height = this._videoElement.videoHeight;
            this._videoSettings.aspectRatio =
                this._videoElement.videoWidth / this._videoElement.videoHeight;
            this._videoCanvas.width = this._videoSettings.width;
            this._videoCanvas.height = this._videoSettings.height;
            this._videoCanvas.style.display = "none";

            this.setVideoCss();
            this.newStatus(componentStatus.RUNNING);
        });
    }

    public checkCompatibility(): boolean {
        const isOK = "mediaDevices" in navigator && "getUserMedia" in navigator.mediaDevices;
        if (isOK) {
            this.newStatus(componentStatus.READY);
        } else {
            return false;
        }
        return isOK;
    }

    public getState() {
        //this._videoSettings.frameRate=this.frameRate||0
        return this._videoSettings;
    }

    public start(): void {
        //console.log("video.start")
        if (this.status == componentStatus.RUNNING || this.status == componentStatus.STARTED) {
            //console.log("Video already started")
            return;
        }
        if (this.status == componentStatus.PAUSED) {
            //console.warn("Video is Paused, can resume")
            this.resume();
            return;
        }
        this.newStatus(componentStatus.STARTED);
        if (this.mp4VideoPath.length > 1) {
            this.runVideoInCanvas();
        } else {
            this.runBestAvailableWebcam();
        }
    }

    private runVideoInCanvas() {
        console.log("runVideoInCanvas");
        this._videoElement.setAttribute("muted", "muted");
        this._videoElement.muted = true;
        this._videoElement.onloadedmetadata = () => {
            this._videoElement.play();
        };
        this._videoElement.src = "";
        this._videoElement.loop = true;
        this._videoElement.src = this.mp4VideoPath;
        try {
            this._videoElement.currentTime = 0;
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * Locate best webcam and try to start it
     */

    private runBestAvailableWebcam() {
        let selectedDevices: Array<MediaDeviceInfo>;
        navigator.mediaDevices
            .enumerateDevices()
            .then(devices => {
                selectedDevices = devices.filter(e => {
                    if ("videoinput" !== e.kind) return false;
                    //eslint-disable-next-line
                    //@ts-ignore
                    if (e.getCapabilities) {
                        //eslint-disable-next-line
                        //@ts-ignore
                        const capabilities = e.getCapabilities();
                        const facingMode = "environment"; //could be changed ?
                        if (
                            capabilities &&
                            capabilities.facingMode &&
                            capabilities.facingMode.indexOf(facingMode) < 0
                        ) {
                            return false;
                        }
                    }
                    return true;
                });
                const isFound: boolean = selectedDevices.length > 0;
                if (isFound) {
                    //eslint-disable-next-line
                    //@ts-ignore
                    this._mediaConstraints.video.deviceId =
                        selectedDevices[selectedDevices.length - 1].deviceId;
                }
                if (navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices
                        .getUserMedia(this._mediaConstraints)
                        .then(stream => {
                            this.stream = stream;
                            this._videoElement.srcObject = stream;
                            this._videoElement.onloadedmetadata = () => {
                                this.videoMaxSize = Math.max(
                                    this._videoElement.videoWidth,
                                    this._videoElement.videoHeight
                                );
                                this.frameRate = stream.getVideoTracks()[0].getSettings().frameRate;
                                this._videoElement.play();
                            };
                        })
                        .catch(function(err) {
                            console.error("err video:" + err);
                        });
                } else {
                    console.error("err video:navigator.mediaDevices.getUserMedia  not found");
                }
            })
            .catch(function(err) {
                console.error("err video:" + err);
            });
    }

    /**
     * Stop the video and the canvas drawing
     */
    public stop(): void {
        this._videoElement.pause();
        if (this.stream) {
            this.stream.getVideoTracks()[0].stop();
        }
        this.newStatus(componentStatus.READY);
    }

    public render(): void {
        if (this.status != componentStatus.RUNNING) {
            return;
        }
        this.context2d.drawImage(
            this._videoElement,
            0,
            0,
            this._videoElement.videoWidth,
            this._videoElement.videoHeight
        );
    }

    //specific fundtions

    public pause(): void {
        if (this.status == componentStatus.RUNNING) {
            this._videoElement.pause();
            this.newStatus(componentStatus.PAUSED);
        }
    }

    public resume(): void {
        if (this.status == componentStatus.PAUSED) {
            this._videoElement.play();
            //this.newStatus(componentStatus.RUNNING)
        }
    }

    public getCanvas(isSync = false): HTMLCanvasElement {
        return this._videoCanvas;
    }

    public getVideoElement(): HTMLVideoElement {
        return this._videoElement;
    }

    public getFrame() {
        this.imageDataSync = this.context2d.getImageData(
            0,
            0,
            this._videoCanvas.width,
            this._videoCanvas.height
        );
        return this.imageDataSync;
    }

    private setVideoCss() {
        //console.log("setVideoCss")

        const ratio = this._videoElement.videoWidth / this._videoElement.videoHeight;
        //console.log("videoRatio:"+ratio)
        //console.log("screenRatio:"+window.innerWidth/window.innerHeight)
        //let ratio =this._videoSettings.aspectRatio //videoWidth sur videoHeight
        if (window.innerWidth / window.innerHeight > ratio) {
            //window is too large. Then we hide some height
            //console.log("Hide some height")
            this._videoElement.style.width = "100vw";
            this._videoElement.style.height = String(100 / ratio) + "vw";
            this._videoElement.style.left = "0";
        } else {
            //we hide some width
            this._videoElement.style.width = String(ratio * 100) + "vh";
            this._videoElement.style.left =
                (window.innerWidth - window.innerHeight * ratio) / 2 + "px";
            this._videoElement.style.height = "100vh";
        }
        this._videoElement.style.position = "absolute";
        this._videoElement.style.top = "0";
        this._videoElement.style.display = "block";
    }

    public videoDisplay(): void {
        this._videoElement.style.display = "block";
    }

    public onResize(): void {
        console.log("onResize");
        if (this.status < componentStatus.STARTED) {
            //console.log("no changing video because status is "+this.status)
            return;
        }
        this.runBestAvailableWebcam();
        this.setVideoCss();
        this.newStatus(componentStatus.STARTED);
        this.newStatus(componentStatus.RUNNING);
        //console.log("video.onResize done")
    }
}